import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useQuery, UseQueryOptions } from 'react-query'
import { sendToApi } from 'api/client'
import { ToolCallResponse } from 'api/clients/AiClient'

interface Props {
  id?: string
}

export type SuccessfulCaptionGenerationResponse = { status: 'done'; data: ToolCallResponse[] }

export type CaptionGenerationResponse =
  | { status: 'started' | 'processing' | 'failed' }
  | SuccessfulCaptionGenerationResponse

export const useAICaptionGeneration = ({ id }: Props, options?: UseQueryOptions<CaptionGenerationResponse>) => {
  return useQuery<CaptionGenerationResponse>(
    ['aiTemplateAnalysis', 'detail', id],
    async () => {
      const res = await sendToApi<CaptionGenerationResponse>(`/caption-generation?job_id=${id}`)
      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error()
      }
      return res.data
    },
    {
      enabled: !!id,
      refetchOnWindowFocus: false,
      ...options,
    },
  )
}
